import { createReduxModule } from 'hooks-for-redux'
import { THEME_MODE_LOCAL_STORAGE_KEY } from 'lib/constants'
import { darkModeFlag } from 'lib/utils/featureFlags'

export type ThemeModeType = 'light' | 'dark'

const readStoredMode = (): ThemeModeType =>
  darkModeFlag && localStorage.getItem(THEME_MODE_LOCAL_STORAGE_KEY) === 'dark' ? 'dark' : 'light'

// index.css keys the dark palette off this attribute.
const applyMode = (mode: ThemeModeType) => {
  document.documentElement.dataset.theme = mode
}

const initialState: ThemeModeType = readStoredMode()
applyMode(initialState)

export const [use, { setThemeMode, toggleThemeMode }, store] = createReduxModule('themeMode', initialState, {
  setThemeMode: (state: ThemeModeType, mode: ThemeModeType) => {
    localStorage.setItem(THEME_MODE_LOCAL_STORAGE_KEY, mode)
    applyMode(mode)
    return mode
  },
  toggleThemeMode: (state: ThemeModeType) => {
    const mode: ThemeModeType = state === 'dark' ? 'light' : 'dark'
    localStorage.setItem(THEME_MODE_LOCAL_STORAGE_KEY, mode)
    applyMode(mode)
    return mode
  },
})

// Logout wipes localStorage; the theme is a device preference, so keep it.
export const clearLocalStorage = () => {
  const mode = localStorage.getItem(THEME_MODE_LOCAL_STORAGE_KEY)
  localStorage.clear()
  if (mode) localStorage.setItem(THEME_MODE_LOCAL_STORAGE_KEY, mode)
}
